module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.active) ? _c('div', {
    staticClass: "event-tab"
  }, [_c('notes', {
    attrs: {
      "event": _vm.event
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdca29a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventNotesTab.vue
// module id = 2358
// module chunks = 0